<template>
    <div class="range">
        <input :max="max" :min="min" :step="step" type="range" v-model="value">
    </div>
</template>

<script>
import { computed, defineComponent } from 'vue'

export default defineComponent({
    name: 'Range',
    props: {
        max: {
            type: String,
            required: false,
            default: ''
        },
        min: {
            type: String,
            required: false,
            default: ''
        },
        step: {
            type: String,
            required: false,
            default: '1'
        },
        modelValue: {
            type: Number,
            required: false,
            default: 0
        }
    },
    emits: ['update:modelValue'],
    setup (props, { emit }) {
        const value = computed({
            get () {
                return props.modelValue
            },
            set (value) {
                emit('update:modelValue', value)
            }
        })

        return {
            value
        }
    }
})
</script>

<style lang="scss" scoped>
@mixin trackStyle {
    width: 100%;
    height: 6px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 0 0 1px rgba(0, 0, 0, .3);
    background: var(--primary-color);
    border-radius: var(--radius);
    border: 1px solid var(--dark-primary-color);
}

@mixin thumbStyle {
    box-shadow: 0 0 1px rgba(0, 0, 0, .3);
    border: 1px solid var(--divider-color);
    height: 18px;
    width: 18px;
    border-radius: 50%;
    background: var(--default-color);
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -8px;
}

.range {
    input[type=range] {
        -webkit-appearance: none;
        width: 100%;
        margin: 10px 0;

        &:focus {
            outline: none;
        }

        &::-webkit-slider-runnable-track {
            @include trackStyle;
        }

        &::-moz-range-track {
            @include trackStyle;
        }

        &::-webkit-slider-thumb {
            @include thumbStyle;
            margin-top: -7px;
        }

        &::-moz-range-thumb {
            @include thumbStyle;
        }
    }
}
</style>
